import EditFieldModal from "@/modules/common/components/modals/edit-field-modal";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { downloadFile } from "@/modules/common/utils";
import ModalFooter from "@/modules/common/components/modals/modal-footer";
import PDFViewer from "@/modules/common/components/pdfviewer";

interface PdfViewerModalProps {
  open: boolean;
  setOpen: (arg0: boolean) => void;
  headerText: string;
  source?: string | ArrayBuffer;
  fileUrl?: string;
  handleClose?: () => void;
  isLoading?: boolean;
}

export default function PdfViewerModal({
  open,
  setOpen,
  headerText,
  source,
  fileUrl,
  handleClose,
  isLoading,
}: PdfViewerModalProps) {
  const onClose = () => {
    handleClose?.();
  };

  const renderFooter = () => {
    if (fileUrl) {
      return (
        <ModalFooter
          handleClose={onClose}
          cancelButton={<Box></Box>}
          applyButton={
            <Button variant="contained" onClick={() => downloadFile(fileUrl)}>
              Download
            </Button>
          }
        />
      );
    }
    return null;
  };

  return (
    <EditFieldModal
      open={open}
      setOpen={setOpen}
      handleCloseModal={onClose}
      header={headerText}
      modalFooter={false}
    >
      {isLoading ? (
        <CircularProgress />
      ) : source ? (
        <>
          <PDFViewer source={source} />
          {renderFooter()}
        </>
      ) : (
        <Typography>No PDF available to display.</Typography>
      )}
    </EditFieldModal>
  );
}
